import React from 'react';
import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
    color?: string;
    size?: number;
};

const Bell05Icon = ({
    color = 'currentColor',
    size = 24,
    strokeWidth = 2,
    strokeLinecap = 'round',
    strokeLinejoin = 'round',
    ...props
}: Props) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width={size} height={size} {...props}>
        <path
            stroke={color}
            strokeLinecap={strokeLinecap}
            strokeLinejoin={strokeLinejoin}
            strokeWidth={strokeWidth}
            d="M15.694 18.667c0 1.84-1.537 3.333-3.433 3.333s-3.433-1.492-3.433-3.333m10.298-10a6.57 6.57 0 0 0-2.011-4.714A6.97 6.97 0 0 0 12.26 2c-1.82 0-3.567.702-4.855 1.953a6.57 6.57 0 0 0-2.01 4.714c0 3.433-.893 5.784-1.89 7.339-.84 1.312-1.26 1.968-1.245 2.15.017.203.062.28.23.401.152.11.836.11 2.205.11h15.13c1.369 0 2.053 0 2.205-.11.168-.12.212-.198.23-.4.015-.183-.405-.84-1.246-2.151-.996-1.555-1.888-3.906-1.888-7.34"
        />
    </svg>
);
export { Bell05Icon };
